import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReceiptionBell: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconReceiptionBell"><Path d="M12 6.5C7.30558 6.5 3.5 10.4844 3.5 16.3281V17.5H20.5V16.3281C20.5 10.4844 16.6944 6.5 12 6.5ZM12 6.5V3.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.49609 20.5H20.4961" stroke="currentColor" strokeLinecap="square"/><Path d="M12 17.5V20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 3.5H14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconReceiptionBell;
